import { render, staticRenderFns } from "./selectPop.vue?vue&type=template&id=6b1ddec3&scoped=true"
import script from "./selectPop.vue?vue&type=script&lang=js"
export * from "./selectPop.vue?vue&type=script&lang=js"
import style0 from "./selectPop.vue?vue&type=style&index=0&id=6b1ddec3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1ddec3",
  null
  
)

export default component.exports